import { createSlice, isAnyOf, type PayloadAction } from '@reduxjs/toolkit';

import { rewardsApi } from '@/api/queries/rewards';
import { type TwoTypesReward } from '@/common/types/earnRewardsType';

interface EarnRewardsState {
  rewards: TwoTypesReward | null;
}

const initialState: EarnRewardsState = {
  rewards: null,
};

const earnRewardsSlice = createSlice({
  name: 'earnRewards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        rewardsApi.endpoints.getRewards.matchFulfilled,
        rewardsApi.endpoints.claimEarnRewards.matchFulfilled,
      ),
      (state, { payload }: PayloadAction<TwoTypesReward>) => {
        if (payload) {
          state.rewards = {
            rewards: payload.rewards,
            nextClaimTime: payload.nextClaimTime,
          };
        }
      },
    );
  },
});

export default earnRewardsSlice.reducer;
